import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getData({ status, page, limit = 20, sortOrder = 'desc', sortBy, tracking_id, rut, email }, token) {
		const params = { 
			status, 
			page, 
			limit, 
			sortOrder,
			country: Enviroment.COUNTRY,
		};


		if (tracking_id) params.tracking_id = tracking_id;
		if (rut) params.rut = rut;
		if (email) params.email = email;

		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/tracking-order/by-payment-status`,
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getDataByPurchaseId(purchaseId) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${purchaseId}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async removeRecipe({ quotationId, recipe_id, token }) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/recipes/remove`,
			data: { recipe_id },
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	

	async updateRecipe(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/recipes`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


		async updateUserInfo(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/user-info`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

		async resendQuotationEmail(quotationId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/resend-approved-email`,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async processNewStatus(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/status`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async uploadImage(formData) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/resources/${Enviroment.COUNTRY}`,
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async addComercialProductsToQuotation(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	
	async addMagistralProductsToQuotation(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/magistral-ready`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async exportQuotations(token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/export`,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async requote(body,token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/requote`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}



	async addMagistralToMakeProducts(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async removeCommercialProduct(productId, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial/${productId}/remove`,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async removeMagistralProduct(productId, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/remove`,
			data:{product_id:productId},
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async updateMagistralProducts(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateCommercialProducts(body, quotationId, productId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial/${productId}`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
		async getPreorderList({ status, page, pharmacy, limit = 20, short_code, user_email, user_rut, sortOrder }, token) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/tracking-order/by-payment-status`,
			params: { page:page, limit:limit, country:Enviroment.COUNTRY, pharmacy,status, short_code, user_email, user_rut, sortOrder },
			headers: {
				Authorization: `Bearer ${token}`,
			},	
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

		async getPreorderDetail(purchaseId, token) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/tracking-order/detail/by-purchase/${purchaseId}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},	
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

		async getPaymentTrackingDetail(paymentTrackingId, token) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/payments/tracking/${paymentTrackingId}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},	
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

		async changeStatusPreorder(paymentTrackingId, status, token) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.FUNCTION_BACKEND}/payments/manual-payment/${paymentTrackingId}/${status}`,
			data: {},
			headers: {
				Authorization: `Bearer ${token}`,
			},	
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

		async updatePaymentVoucher(paymentTrackingId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/payments/${paymentTrackingId}/voucher`,
			headers: {
				Authorization: `Bearer ${token}`,
			},	
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async uploadToSignedUrl(signedUrl, file) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: signedUrl,
			data: file,
			headers: {
				'Content-Type': file.type || 'application/octet-stream',
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
